import { Record, Map, List } from 'immutable';

export default class VariantRecord extends Record({
  key: '',
  name: '',
  script: '',
  selected: false,
  dimensions: new Map({ width: 0, height: 0 }),
  components: new List(),
  backgroundColor: '#FFFFFF',
}) {
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/records/VariantRecord.js